import React from 'react';
import { connect } from 'react-redux';
import { fetchPropertiesUnitsTenants } from '../../redux/middleware/properties';
import store from '../../redux/store';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';
import _ from 'lodash';
import {
    UncontrolledTooltip,
    Row,
    Nav,
    NavLink,
    Col,
} from 'reactstrap';

import {
    showLoading,
    fetchPropertyTenants,
    showCustomMessage,
    saveBankStatementTransactions,
    fetchOptions
} from '../../redux/actions';
import { IonAlert, IonButton, IonCheckbox, IonIcon, IonList, IonRow } from '@ionic/react';

import ReviewTransactionsListItems from './reviewTransactionsListItems';
import { Card } from '@tremor/react';
import { informationCircle, options } from 'ionicons/icons';
import { sortArchivedTenants } from '../../utils';

const mapStateToProps = state => ({
    properties: state.properties,
    units: state.units,
    tenants: state.tenants,
    options: state.options,
})

const mapDispatchToProps = {
    showLoading,
    fetchPropertyTenants,
    showCustomMessage,
    saveBankStatementTransactions,
    fetchOptions
}

const FILTER_TRANSACTION_TYPES = {
    "payment": "Payments",
    "withdrawal": "Withdrawals",
    "duplicates": "Duplicates",
}

class ReviewTransactions extends React.Component{
    constructor(props){
        super(props);
        const defaultTenantOptions = {};
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            transactions: [],
            filteredTransactions: [],
            transactionsToSave: [],
            transactionType: ["payment"],
            filterTransactionType: "payment",
            propertyIds: [],
            searchText: {},
            defaultTenantOptions,
            tenantOptions: sortArchivedTenants(Object.values(defaultTenantOptions)),
            isTenantFilterLoading: false,
            openAlert: false,
            payments: [],
            numPaymentsWithoutTenant: 0,
            allTransactionsSelected: -1
        }
        this.transactionTypeRefs = {};
        for (let transactionType of Object.keys(FILTER_TRANSACTION_TYPES)){
            this.transactionTypeRefs[transactionType] = React.createRef();
        }
    }

    async componentDidMount(){
        if (_.isEmpty(this.props.properties)) {
            this.props.showLoading(true);
            await store.dispatch(fetchPropertiesUnitsTenants);
        }
        if (_.isEmpty(this.props.options)) {
            this.props.showLoading(true);
            await this.props.fetchOptions();
        }
        this.props.showLoading(false);
        this.refetchTransactions();
    }

    refetchTransactions(){
        let transactions = [];
        let defaultTenantOptions = {};
        let foundPaymentTransaction = false;
        let tempTransaction;
        for(let trans of this.props.transactions){
            let tenant = null;
            if(trans.tenant){
                tenant = this.getTenantOption(trans.tenant);
                if(!(tenant.id in defaultTenantOptions)){
                    defaultTenantOptions[tenant.id] = tenant;
                }

            }
            tempTransaction = {
                ...trans,
                tenant: tenant? [tenant]: [],
                transactionDetails: JSON.parse(trans.transactionDetails)
            };
            transactions.push({ ...tempTransaction });
            if(!foundPaymentTransaction && trans.transactionType == "payment"){
                foundPaymentTransaction = true;
            }
        }
        let transactionType = "all";
        if(foundPaymentTransaction){
            transactionType = "payment";
        }
        this.setState({
            transactions,
            transactionType,
            filteredTransactions: this.filterTransactions(transactions, transactionType),
            tenantOptions: sortArchivedTenants(Object.values(defaultTenantOptions)),
            defaultTenantOptions
        });
    }

    async componentDidUpdate(prevProps, prevState){
        if(prevProps.properties != this.props.properties){
            this.setState({
                propertyIds: Object.keys(this.props.properties)
            });
        }
        if(prevProps.transactions != this.props.transactions){
            this.refetchTransactions();
        }
    }

    beforeSaveCell(oldValue, newValue, row, column, done) {
        done(true);
        this.setState((prevState) => {
            let transactions = this.updateTransactions(prevState.transactions, column["dataField"], newValue, row["uniqueRowId"])
            const filteredTransactions = this.filterTransactions(transactions, prevState.transactionType)
            return ({
                transactions,
                filteredTransactions
            });
        })

        return { async: false };
    }

    updateTransactions(transactions, dataField, newValue, uniqueRowId){
        let newTransactions = [ ...transactions ];
        if(["moneyIn", "moneyOut"].includes(dataField)){
            newValue = parseFloat(newValue);
        }
        for(let i=0; i < newTransactions.length; i++){
            if(newTransactions[i].uniqueRowId == uniqueRowId){
                newTransactions[i] = {
                    ...newTransactions[i],
                    [dataField] : newValue
                };
            }
        }
        return newTransactions;
    }

    filterTransactions(transactions, transactionTypes){
        return transactions.filter(trans => transactionTypes.includes(trans.transactionType));
    }

    handleChangeTenant(uniqueRowId, selected){
        this.setState((prevState) => {
            let transactions = this.updateTransactions(prevState.transactions, "tenant", selected, uniqueRowId);
            let defaultTenantOptions = { ...prevState.defaultTenantOptions };
            if(selected.length > 0){
                defaultTenantOptions[selected[0].id] = selected[0];
            }
            return ({
                transactions,
                filteredTransactions: this.filterTransactions(transactions, prevState.transactionType),
                defaultTenantOptions,
                tenantOptions: sortArchivedTenants(Object.values(defaultTenantOptions))
            });
        });
    }

    updateCellValue(column, value, rowuniqueRowId){
        let formattedValue = value;
        if (column === "date") {
            formattedValue = formattedValue = new Date(value).toISOString();
        }
        let transactions = this.updateTransactions(this.state.transactions, column, formattedValue, rowuniqueRowId);
        let filteredTransactions = this.filterTransactions(transactions, this.state.transactionType);
        this.setState({
            transactions,
            filteredTransactions
        });
    }

    hideSelectTableColum = () =>{
        if(this.props.editingDisabled || this.state.filterTransactionType !== 'payment'){
            return true
        }
        else{
            return false
        }
    }

    onSearchTenant = async (searchText) => {
        let defaultTenantOptions = { ...this.state.defaultTenantOptions };
        const action = await this.props.fetchPropertyTenants({searchText});
        for(let tenant of Object.values(action.payload.tenants)){
            if(!(tenant.tenantId in defaultTenantOptions)){
                defaultTenantOptions[tenant.tenantId] = this.getTenantOption(tenant);
            }
        }
        this.setState({
            defaultTenantOptions,
            tenantOptions: sortArchivedTenants(Object.values(defaultTenantOptions))
        });
    }

    getTenantOption(tenant){
        if (tenant){
            let label = "";
            let accountId = tenant.accountId ? tenant.accountId + " - " : "";
            if(tenant?.archived){
                label += "[Archived] - "
            }
            label += accountId + tenant.firstName + " " + tenant.lastName;
            if(tenant.propertyId in this.props.properties){
                label += " (" + this.props.properties[tenant.propertyId].propertyName

                if(tenant.unitId in this.props.units){
                    label += " : " + this.props.units[tenant.unitId].unitName
                }

                label += ")"
            }

            return {
                id: tenant.tenantId,
                tenantDetails: tenant,
                label
            };
        }{
            return null;
        }
    }

    processPaymentTransaction(trans, payments, numPaymentsWithoutTenant) {
        let updatedNumPaymentsWithoutTenant = numPaymentsWithoutTenant;
        let updatedErrors = null;

        if (trans["moneyIn"] <= 0) {
            updatedErrors = "All payment transactions must have a 'Money In' value greater than 0";
            return {errors: updatedErrors, numPaymentsWithoutTenant: updatedNumPaymentsWithoutTenant, payments: []};
        } else {
            let tenantId = "";
            if (!trans["tenant"] || trans["tenant"].length === 0) {
                updatedNumPaymentsWithoutTenant += 1;
            } else {
                tenantId = trans["tenant"][0].id;
            }
            payments.push({
                "moneyIn": trans["moneyIn"],
                "date": trans["date"].toString(),
                "transactionId": trans["transactionId"],
                "tenantId": tenantId,
                "extraDetailsJson": JSON.stringify(trans["transactionDetails"])
            });
            return {errors: updatedErrors, numPaymentsWithoutTenant: updatedNumPaymentsWithoutTenant, payments:payments};
        }
    }


    async handleSubmit(){
        let payments = [];
        let numPaymentsWithoutTenant = 0;
        let errors;
        for(let trans of this.state.transactions){
            if (this.state.transactionsToSave.length){
                if (this.state.transactionsToSave.includes(trans["transactionId"])){
                    if(trans["transactionType"] == "payment"){
                        const result = this.processPaymentTransaction(trans, payments, numPaymentsWithoutTenant)
                        errors = result.errors;
                        numPaymentsWithoutTenant = result.numPaymentsWithoutTenant;
                        payments = result.payments;
                        if (errors){
                            break
                        }
                    }
                }
            }
        }
        this.setState({
            payments,
            numPaymentsWithoutTenant
        })
        if(errors){
            this.props.showCustomMessage("Error", errors);
        }else if(payments.length == 0){
            this.props.showCustomMessage("Unable to Save Payments!", "There are 0 payment transactions.");
        }else{
            if(numPaymentsWithoutTenant > 0){
                this.setState({openAlert: true})
            }else{
                this.savePaymentsFromBankStatement(payments);
            }
        }
    }

    async savePaymentsFromBankStatement(payments){
        this.props.showLoading(true);
        const action = await this.props.saveBankStatementTransactions(payments);
        this.props.showLoading(false);
        if(!action.errors){
            const createdPayments = action.payload.payments;
            if(createdPayments.length > 0){
                this.props.showCustomMessage("Success", `Successfully created ${createdPayments.length} new payments`)
            }
            this.props.savePayments(createdPayments);
        }
    }

    handleChangeTransactionType(transactionType){
        let transactionTypes = []
        if(transactionType === "duplicates"){
            transactionTypes.push("duplicate", "toDelete")
        }else{
            transactionTypes.push(transactionType)
        }
        this.setState({
            transactionType: transactionTypes,
            filterTransactionType: transactionType,
            filteredTransactions: this.filterTransactions(this.state.transactions, transactionTypes)
        });
    }

    handleTransactionSelected(row, isSelected) {
        if (isSelected) {
            this.setState(prevState => ({
                transactionsToSave: [...prevState.transactionsToSave, row.transactionId]
            }));
        } else {
            const indexToDelete = this.state.transactionsToSave.indexOf(row.transactionId);
            if (indexToDelete !== -1) {
                const newArray = [...this.state.transactionsToSave];
                newArray.splice(indexToDelete, 1);
                this.setState({ transactionsToSave: newArray, allTransactionsSelected: -1 });
            }
        }
    }

    handleAllTransactionsSelected(isSelected, rows){
        if(isSelected){
            this.setState({transactionsToSave: _.map(rows, "transactionId"), allTransactionsSelected: 1})
        }else{
            this.setState( {transactionsToSave: [], allTransactionsSelected: 0 })
        }
    }

    savePaymentsErrorMessage(){
        if(this.props.editingDisabled){
            return "Editing is disabled. Payments cannot be selected or saved"
        }else if (this.state.transactionsToSave.length === 0){
            return "Please first select payment(s) to save"
        }
    }

    render(){
        const disableSavePayments = this.props.editingDisabled || this.state.transactionsToSave.length === 0;
        const { numPaymentsWithoutTenant, payments, openAlert } = this.state;

        return (
            <div>
                {this.props.editingDisabled?
                    (<p className='my-2' style={{color: "red"}}>
                        Note: Editing disabled because payments have already been created
                    </p>) :
                    (<p className='my-2'>Note: Assign Payments to {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenants" : "Members"} if need be. (Scroll right to view duplicate payments)</p>)
                }
            <Row className='mb-2'>
                {/* <Col> */}
                    <Nav pills>
                    <div className="flex p-0 overflow-x-auto">
                        {Object.keys(FILTER_TRANSACTION_TYPES).map((key) => {
                            return (
                            <div
                                ref={this.transactionTypeRefs[key]}
                                className='flex-none py-6 px-3'
                                key={key}
                            >
                                <NavLink
                                active={this.state.filterTransactionType === key}
                                style={{ border: "1px solid #3880ff"}}
                                onClick={(event)=>{
                                    event.preventDefault();
                                    this.transactionTypeRefs[key].current.scrollIntoView();
                                    this.handleChangeTransactionType(key)}
                                    }
                                href={`#${key}`}
                                className=""
                                id={'transactionType' + key}
                                >
                                    {FILTER_TRANSACTION_TYPES[key]}
                                </NavLink>
                            </div>
                        )
                        })}
                    </div>
                    </Nav>
                {/* </Col> */}
            </Row>

            {this.state.filterTransactionType == "payment" && <Row className="d-flex mb-4 pb-3 px-1 border-bottom border-dark">
                <Col xs={1} sm={1} md={1} lg={1}>
                    <IonCheckbox
                        checked={this.state.allTransactionsSelected == 1}
                        disabled={this.props.editingDisabled}
                        onIonChange={(e) => this.handleAllTransactionsSelected(e.target.checked, this.state.filteredTransactions)}
                    />
                </Col>
                <Col xs={10} sm={10} >
                    Select All Payments
                </Col>
            </Row>}

            <IonAlert
                isOpen={openAlert}
                header="Save payments without tenants?"
                message={`Do you wish to save some payments without assigning them to a ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}? There are ${numPaymentsWithoutTenant} out of ${payments.length} payments not assigned to a ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}.`}
                buttons={[
                    {
                        text: "Yes, Save payments",
                        handler: () => {
                            this.savePaymentsFromBankStatement(payments);
                        }
                    },
                    {
                        text: "No, take me back",
                        handler: () => {
                            this.setState({openAlert: false});
                        }
                    }
                ]}
            />

                <div style={{ margin: "0", padding: "0" }}>
                    <IonList  id='ion-list-descriptions' style={{ margin: "0", padding: "0" }}>
                    {this.state.filteredTransactions.map((transaction, index) => {
                        let date = transaction.date || null;
                        let moneyIn = transaction.moneyIn || null;
                        let moneyOut = transaction.moneyOut || null;
                        let transactionId = transaction.transactionId || null;
                        let tenant = transaction.tenant || null;
                        let transactionType = transaction.transactionType || null;
                        let transactionDetails = transaction.transactionDetails || "-";
                        let uniqueRowId = transaction.uniqueRowId || null;
                        let duplicatePayment = transaction.duplicatePayment || null;
                        let phoneNumbers = transactionDetails.phoneNumbers || null;
                    return (
                        <ReviewTransactionsListItems
                            index={index}
                            transaction={transaction}
                            date={date}
                            moneyIn={moneyIn}
                            moneyOut={moneyOut}
                            transactionId={transactionId}
                            tenant={tenant}
                            options={this.props.options}
                            transactionType={transactionType}
                            transactionDetails={transactionDetails}
                            uniqueRowId={uniqueRowId}
                            duplicatePayment={duplicatePayment}
                            phoneNumbers={phoneNumbers}
                            showDetails={false}
                            handleTransactionsSelected={this.handleTransactionSelected.bind(this)}
                            updateCellValue={this.updateCellValue.bind(this)}
                            onSearchTenant={this.onSearchTenant.bind(this)}
                            handleChangeTenant={this.handleChangeTenant.bind(this)}
                            tenantOptions={this.state.tenantOptions}
                            defaultTenantOptions={this.state.defaultTenantOptions}
                            allTransactionsSelected={this.state.allTransactionsSelected}
                            currency={this.props.currency.customerCurrency || ""}
                            isEditingDisabled={this.props.editingDisabled}
                        />
                    )
                    })}
                    </IonList>
                    <hr />
                </div>

                <IonRow className="d-flex my-4 pb-3 border-bottom border-dark justify-content-center align-items-center">
                    <IonButton type="submit"
                        id='savePayments'
                        style={{width: "80%"}}
                        onClick={this.handleSubmit.bind(this)}
                        disabled={disableSavePayments}
                    >
                        Save Selected Payments
                    </IonButton>
                    {disableSavePayments && <IonIcon id='savePayments' icon={informationCircle} />}
                    {disableSavePayments && (<UncontrolledTooltip placement='top' target='savePayments'>
                        {this.savePaymentsErrorMessage()}
                    </UncontrolledTooltip>)}
                    <b className='my-2'>Only selected payments will be saved</b>
                    </IonRow>
            </div>
        )
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReviewTransactions);
